"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SessionCreatePayloadSchema = exports.SessionTokenPayloadSchema = exports.SessionObjectSchema = exports.SessionMetadataSchema = void 0;
const zod_1 = require("zod");
exports.SessionMetadataSchema = zod_1.z
    .record(zod_1.z.string(), zod_1.z.unknown())
    .openapi('SessionMetadata');
exports.SessionObjectSchema = zod_1.z
    .object({
    id: zod_1.z.string(),
    object: zod_1.z.literal('session'),
    token: zod_1.z.string(),
    metadata: exports.SessionMetadataSchema,
    created_at: zod_1.z.date().openapi({ type: 'string', format: 'date-time' }),
})
    .openapi('SessionObject');
exports.SessionTokenPayloadSchema = zod_1.z
    .object({
    sub: zod_1.z.string(),
})
    .openapi('SessionTokenPayload');
// Create
exports.SessionCreatePayloadSchema = zod_1.z
    .object({
    metadata: exports.SessionMetadataSchema.optional(),
})
    .openapi('SessionCreatePayload');
//# sourceMappingURL=sessionSchema.js.map